import React from 'react';

const AdminPage = () => {
    React.useEffect(() => {
        window.location.href = 'https://superb-festival-c4d006d9d8.strapiapp.com/';
    }, []);

    return (
        <div></div>
    );
};

export default AdminPage;